import qs from 'query-string'

/** Subdomain/token resolution shared by sendRequest and Aptexx outcome logging. */
export function getRequestContext() {
    let subdomain = window.location.host.split('.')[1] ? window.location.host.split('.')[0] : process.env.VUE_APP_DEFAULT_RESELLER
    let token

    if (subdomain === 'microsite') {
        subdomain = process.env.VUE_APP_DEFAULT_RESELLER
    }

    // if we're going through the order subdomain, we look at the query string
    if (subdomain === process.env.VUE_APP_ORDER_SUBDOMAIN) {
        const parsedParams = qs.parse(location.search)

        if (parsedParams.token) {
            token = parsedParams.token
            subdomain = null
        } else if (parsedParams.subdomain) {
            subdomain = parsedParams.subdomain
        } else {
            subdomain = process.env.VUE_APP_DEFAULT_RESELLER
        }
    }

    return { subdomain, token }
}

/** Normalize reseller subdomain keys from short keys or full custom_url hostnames. */
export function normalizeSubdomainKey(value) {
    if (value == null || value === '') {
        return null
    }

    const raw = String(value).split(' ')[0].trim()
    if (!raw) {
        return null
    }

    if (!raw.includes('.')) {
        return raw
    }

    return raw.split('.')[0] || null
}

/** Short reseller key from microsite meta when hostname parsing is unavailable. */
export function subdomainFromMicrositeMeta(meta) {
    if (!meta) {
        return null
    }

    return normalizeSubdomainKey(meta.subdomain || meta.custom_url)
}

/** Prefer hostname/query subdomain; fall back to normalized microsite meta. */
export function resolveOrderSubdomain(meta) {
    const { subdomain } = getRequestContext()
    return subdomain || subdomainFromMicrositeMeta(meta)
}

export const sendRequest = async (path, type = 'GET', params = {}, headers = {}) => {
    type = type.toUpperCase()

    const { subdomain: contextSubdomain, token: contextToken } = getRequestContext()
    let queryParams = ''
    let requestBody = null
    let responseBody = null
    
    // default to GET if not a valid request types
    const requestType = ['GET', 'POST', 'PUT', 'DELETE'].includes(type) ? type : 'GET'

    const combinedParams = { ...params }
    if (!combinedParams.subdomain && contextSubdomain) {
        combinedParams.subdomain = contextSubdomain
    }
    if (combinedParams.subdomain) {
        combinedParams.subdomain = normalizeSubdomainKey(combinedParams.subdomain)
    }
    const combinedHeaders = { ...headers, ...(contextToken && !headers.token && { token: contextToken }) }

    // if request is GET or DELETE make params as query string
    if (type === 'GET' || type === 'DELETE') {
        queryParams = `?${qs.stringify(combinedParams)}`
    // if request is POST or PUT put the params in the request body
    } else {
        requestBody = combinedParams
    }
    
    // If the default backend path is not set, dont send the request
    if (process.env.VUE_APP_OFFLINE === 'false' && process.env.VUE_APP_API_URL) {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/${path}${queryParams}`, {
            method: requestType,
            headers: { 'Content-Type': 'application/json', ...combinedHeaders },
            body: requestBody ? JSON.stringify(requestBody) : null
        }).catch(() => null)

        if (!response) {
            return null
        }

        try {
            responseBody = await response.json()
        } catch {
            responseBody = null
        }        
    }

    return responseBody

}